import { Col, Form, Input, Row } from "antd";
import { useGetFullNameFormRules } from "../../../lib/hooks/getFullNameFormRules";

type FullNameFormItemsProps = {
  isDisabled?: boolean;
  initialValues?: any;
};

export const FullNameFormItems = ({
  isDisabled,
  initialValues,
}: FullNameFormItemsProps) => {
  const { formOptions } = useGetFullNameFormRules();

  return (
    <>
      {formOptions.map((item: any, i: number) => (
        <Row className="align-center mb-4" key={i}>
          <Col span={8}>
            <span className="text-md title">{item.label}</span>
          </Col>
          <Col span={16}>
            <Form.Item
              name={item.name}
              className="mb-0"
              rules={item.rules}
              initialValue={
                initialValues ? initialValues[item.name] : undefined
              }
            >
              <Input disabled={isDisabled} />
            </Form.Item>
          </Col>
        </Row>
      ))}
    </>
  );
};
